"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaSerie = exports.yupSerie = void 0;
const yup = __importStar(require("yup"));
exports.yupSerie = yup.object({
    idProximoCurso: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Próximo Curso'),
    idProximaSerie: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Próxima Série'),
    hasAtitude: yup.boolean().required().default(false).label('Usa atitude'),
    idCurso: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .label('Curso'),
    idAtitude: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Atitude'),
    idSistemaAvaliacao: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Sistema Avaliação'),
    serie: yup.string().default('').max(1).required().label('Série'),
    descricao: yup.string().default('').max(50, 'Máximo de 50 caracteres.').required().label('Descrição'),
    tipoaval: yup.string().default('A').oneOf(['A', 'D']).required().default('A').label('Forma de avaliação'),
    seriePer: yup.boolean().required().default(false).label('Próxima série personalizada'),
    avaliacao: yup.string().max(500, 'Máximo de 500 caracteres.').default('').label('Sintese do sistema de avaliação'),
    obsFinal: yup.string().max(500, 'Máximo de 500 caracteres.').default('').label('Observação do relatório final'),
    marfin: yup.boolean().required().default(false).label('Não enviar MARFIN'),
    nRematric: yup.boolean().required().default(false).label('Não rematricular'),
    obsAluno: yup
        .string()
        .max(500, 'Máximo de 500 caracteres.')
        .default('')
        .label('Observação do aluno no relatório final'),
});
exports.schemaSerie = exports.yupSerie.shape({});
